import React from "react";
import { useAuth } from "@/lib/auth";
import { CurrencyEur } from "@phosphor-icons/react";

const fmtEur = (n) => `€ ${Number(n || 0).toLocaleString("it-IT", { minimumFractionDigits: 2, maximumFractionDigits: 2 })}`;

function Row({ label, value, testid, strong }) {
  return (
    <div className="flex items-center justify-between py-4 border-b last:border-b-0">
      <span className="text-sm text-muted-foreground">{label}</span>
      <span
        className={`font-display tracking-tight ${strong ? "text-2xl font-bold text-purple-700" : "text-lg font-semibold text-slate-800"}`}
        data-testid={testid}
      >
        {value}
      </span>
    </div>
  );
}

export default function PlafondSummary() {
  const { user } = useAuth();
  const limit = Number(user?.plafond_monthly_limit || 0);
  const used = Number(user?.plafond_used_current_month || 0);
  const remaining = limit - used;

  return (
    <div className="flex justify-center pt-6 md:pt-12" data-testid="plafond-summary-page">
      <div className="w-full max-w-md rounded-2xl border bg-white p-6 md:p-8 shadow-sm fade-up">
        <div className="flex items-center gap-3 mb-4">
          <div className="w-10 h-10 rounded-md flex items-center justify-center bg-purple-50 text-purple-700">
            <CurrencyEur size={22} weight="duotone" />
          </div>
          <div>
            <div className="label-eyebrow">Plafond</div>
            <h1 className="font-display text-2xl font-bold tracking-tight">Riepilogo mensile</h1>
          </div>
        </div>
        <Row label="Plafond assegnato mensile" value={fmtEur(limit)} testid="plafond-limit" />
        <Row label="Plafond utilizzato" value={fmtEur(used)} testid="plafond-used" />
        <Row label="Plafond rimanente" value={fmtEur(remaining)} testid="plafond-remaining" strong />
      </div>
    </div>
  );
}
